import React, {Component} from "react";
import {Tabs} from "antd";
import {Route, Switch, withRouter} from 'react-router-dom';
import CommToolContext from "../common/comm_tool_context";
import ProjectTabsList from "components/ProjectTabsList";
import ProjectTabsNavBar from "../../components/ProjectTabsList/ProjectTabsNavBar";

class ReleaseTabs extends Component {

    constructor(props) {
        super(props);
    }

    state = {
      teamMembers :[]
    };

    async componentDidMount() {
        const {
            setActiveProject,
        } = this.props.context;
        setActiveProject(this.props.project);
    }

    render() {
        const {project,status, history, match} = this.props;
        return (
            <CommToolContext.Consumer>
                {context => (
                    <ProjectTabsNavBar project={project} context={context} location={status}/>
                )}
            </CommToolContext.Consumer>
        );
    }
}

ReleaseTabs.contextType = ReleaseTabs;
export default withRouter(ReleaseTabs);
